import React from "react"

import { s } from "../../../../../utilities/common"

export const PlaylistStarIcon = ({
  focused,
  isFavorite = false,
}: {
  focused: boolean
  isFavorite?: boolean
}) => {
  return isFavorite ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={s("40")}
      height={s("40")}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M20 28.833L13.125 34.083C12.875 34.2777 12.604 34.368 12.312 34.354C12.0207 34.34 11.75 34.2497 11.5 34.083C11.278 33.9163 11.1043 33.7013 10.979 33.438C10.8543 33.174 10.8473 32.8753 10.958 32.542L13.583 24L6.833 19.167C6.55567 19.0003 6.382 18.764 6.312 18.458C6.24267 18.1527 6.24967 17.875 6.333 17.625C6.44434 17.375 6.611 17.1527 6.833 16.958C7.05567 16.764 7.33367 16.667 7.667 16.667H16L18.667 7.792C18.7777 7.45867 18.958 7.20167 19.208 7.021C19.458 6.84033 19.722 6.75 20 6.75C20.278 6.75 20.542 6.84033 20.792 7.021C21.042 7.20167 21.2223 7.45867 21.333 7.792L24 16.667H32.333C32.6663 16.667 32.9443 16.764 33.167 16.958C33.389 17.1527 33.5557 17.375 33.667 17.625C33.7503 17.875 33.7573 18.1527 33.688 18.458C33.618 18.764 33.4443 19.0003 33.167 19.167L26.417 24L29.042 32.542C29.1527 32.8753 29.1457 33.174 29.021 33.438C28.8957 33.7013 28.722 33.9163 28.5 34.083C28.25 34.2497 27.9793 34.34 27.688 34.354C27.396 34.368 27.125 34.2777 26.875 34.083L20 28.833Z"
        fill={focused ? "black" : "white"}
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={s("40")}
      height={s("40")}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M14.875 29.167L20 25.25L25.125 29.167L23.125 22.667L27.875 19.5H22.125L20 12.958L17.875 19.5H12.125L16.875 22.667L14.875 29.167ZM20 28.833L13.125 34.083C12.875 34.2777 12.604 34.368 12.312 34.354C12.0207 34.34 11.75 34.2497 11.5 34.083C11.278 33.9163 11.1043 33.7013 10.979 33.438C10.8543 33.174 10.8473 32.8753 10.958 32.542L13.583 24L6.833 19.167C6.55567 19.0003 6.382 18.764 6.312 18.458C6.24267 18.1527 6.24967 17.875 6.333 17.625C6.44434 17.375 6.611 17.1527 6.833 16.958C7.05567 16.764 7.33367 16.667 7.667 16.667H16L18.667 7.792C18.7777 7.45867 18.958 7.20167 19.208 7.021C19.458 6.84033 19.722 6.75 20 6.75C20.278 6.75 20.542 6.84033 20.792 7.021C21.042 7.20167 21.2223 7.45867 21.333 7.792L24 16.667H32.333C32.6663 16.667 32.9443 16.764 33.167 16.958C33.389 17.1527 33.5557 17.375 33.667 17.625C33.7503 17.875 33.7573 18.1527 33.688 18.458C33.618 18.764 33.4443 19.0003 33.167 19.167L26.417 24L29.042 32.542C29.1527 32.8753 29.1457 33.174 29.021 33.438C28.8957 33.7013 28.722 33.9163 28.5 34.083C28.25 34.2497 27.9793 34.34 27.688 34.354C27.396 34.368 27.125 34.2777 26.875 34.083L20 28.833Z"
        fill={focused ? "black" : "white"}
      />
    </svg>
  )
}
